import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH(meetingId, properties /** ???: queryParams, still needed here ?? */) {
      var processedQueryParams = {};
      processedQueryParams.pagination = false;

      // Properties fields
      let propertiesString = "";
      if (properties) {
        properties.forEach(prop => {
          if (typeof prop == "string") {
            propertiesString += `&properties[]=${prop}`;
          } else if (typeof prop == "object") {
            for (const [key, values] of Object.entries(prop)) {
              for (const value of values) {
                propertiesString += `&properties[${key}][]=${value}`;
              }
            }
          }
        });
      }

      return this.get(links.MANDATE_FETCH(meetingId, propertiesString), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    UPDATE_MULTIPLE_LAST_SEEN(mandates) {
      return this.post(links.MANDATE_UPDATE_MULTIPLE_LAST_SEEN(), { mandates }, { save: false });
    },
    MANDATE_CORRESPONDENCE_VOTING(item) {
      return this.post(links.MANDATE_CORRESPONDENCE_VOTING(), item, { save: false });
    },
    MANDATE_SIGN_CORRESPONDENCE(mandateId) {
      return this.get(links.MANDATE_SIGN_CORRESPONDENCE(mandateId), { save: false });
    },
  },
};
